type UnionFromObject<T> = T[keyof T];

export const accountStatuses = {
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  PENDING_ACTIVATION: 'PendingActivation',
} as const;
export type AccountStatus = UnionFromObject<typeof accountStatuses>;

export const accountCountries = {
  AUSTRALIA: 'Australia',
  NEW_ZEALAND: 'New Zealand',
  SINGAPORE: 'Singapore',
  INDONESIA: 'Indonesia',
  MALAYSIA: 'Malaysia',
  PHILIPPINES: 'Philippines',
  HONG_KONG: 'Hong Kong',
  THAILAND: 'Thailand',
  OTHER: 'Other',
} as const;
export type AccountCountry = UnionFromObject<typeof accountCountries>;

export const cardTypes = {
  VISA: 'VISA',
  MASTER_CARD: 'MC',
  AMEX: 'AMEX',
  DINERS: 'DINE',
} as const;
export type CardType = UnionFromObject<typeof cardTypes>;

export const paymentMethods = {
  ADJUSTMENTS: 'Adjustments',
  CANCELLATION: 'Cancellation',
  CHEQUE: 'Cheque',
  CREDIT_CARD: 'Credit Card',
  CREDIT_MEMO: 'Credit Memo',
  EFTPOS: 'EFT',
  MANUAL_ADJUSTMENT: 'Payment - Others',
  WRITE_OFF: 'Write off',
} as const;
export type PaymentMethod = UnionFromObject<typeof paymentMethods>;

export const roles = {
  STANDARD_USER: 'User',
  ADMINISTRATOR: 'Administrator',
} as const;
export type AccountRole = UnionFromObject<typeof roles>;

export const paymentCountries = {
  AUSTRALIA: 'AU',
  NEW_ZEALAND: 'NZ',
  SINGAPORE: 'SG',
  INDONESIA: 'ID',
  MALAYSIA: 'MY',
  PHILIPPINES: 'PH',
  HONG_KONG: 'HK',
  THAILAND: 'TH',
};

export type PaymentCountry = UnionFromObject<typeof paymentCountries>;

export const queryStatuses = {
  DUE: 'due',
  PAID: 'paid',
} as const;
export type QueryStatus = UnionFromObject<typeof queryStatuses>;

export const invoiceStatuses = {
  PENDING: 'pending',
  DUE: 'due',
  PAID: 'paid',
  PARTIAL_PAYMENT: 'partialpay',
  NOT_APPLICABLE: 'na',
  UNCOLLECT: 'uncollect', // When a small amount owed, it is written-off
  COLLECTFEE: 'collectfee', // when paid through the collection agency
  UNCLAIM: 'unclaim', // when unable to collect money
} as const;
export type InvoiceStatus = UnionFromObject<typeof invoiceStatuses>;

export const authenticationStatuses = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
} as const;
export type AuthenticationStatus = UnionFromObject<
  typeof authenticationStatuses
>;

export const apiStatuses = {
  // An error has occurred. Do not automatically retry.
  ERROR: 'error',
  // Loading information. Show loading state
  LOADING: 'loading',
  // Has loaded information. Retry for latest information
  LOADED: 'loaded',
} as const;
export type ApiStatus = UnionFromObject<typeof apiStatuses>;

export const downloadingStatuses = {
  // An error has occurred. Do not automatically retry.
  ERROR: 'error',
  // Currently downloading
  DOWNLOADING: 'downloading',
  // Finished downloading
  DOWNLOADED: 'downloaded',
} as const;
export type DownloadStatus = UnionFromObject<typeof downloadingStatuses>;

export const invoiceDocumentTypes = {
  INVOICE: 'Invoice',
  CREDIT_NOTE: 'Credit Note',
} as const;
export type InvoiceDocumentType = UnionFromObject<typeof invoiceDocumentTypes>;

export const paymentSources = {
  WEB: 'web',
  CRM: 'crm',
  EMAIL: 'email',
  UNKNOWN: 'unknown',
} as const;
export type PaymentSource = UnionFromObject<typeof paymentSources>;
